import { styled } from '@linaria/react';
import { memo } from 'react';
import { SearchType } from '../../../../types';
import type { SearchResultEntry, SearchResultEntryWithType, SearchResults as TSearchResults, TabTypes } from '../../../../types/state';
import { openMenuDialog } from '../../../actions/menu';
import { TransitionTypes } from '../../../state';
import { openRoom } from '../../../state/state.rooms';
import { safeObj } from '../../../utilities/safe';
import { LoadingData } from '../../common/LoadingData';
import SearchRecommendations from '../SearchRecommendations';
import NoResults from './NoResults';
import "./SearchResults.linaria.module.css!=!./SearchResults?./SearchResults.linaria.module.css?css=H4sIAAAAAAAAA32OzU7DMBCE77wHEhxcJahCwnkTLpEbr+0t6x/sTZPW4t1RQaHJodxm9tsZza68jN595uoArWPZNs1jN6Fm9yu9msUapViQMQaZgRTjCToxweEDWXBWoZiYvfxRpBjen5rnTvh4+QeWu+ze/RCzhiw4JkFgWGSlcSxyn+Y1ytfNazYhkRicChbkX3X39bBT7HuKPepk7H7ralJaY7DXRtksz2+lb3me8ERVY0mkztIQzAt2fete43G8bF1VhDYIZPBFDhAY8pIwwyZys/U4FkZzFkMMDIFvuW+FQ25uuAEAAA=="
const SearchResultRoot = /*#__PURE__*/styled('div')({
  name: "SearchResultRoot",
  class: "s2umhqr",
  propsAsIs: false
});
const noResultStyles = "atm_lo_idpfg4 atm_9s_1txwivl atm_h_1h6ojuz atm_fc_1h6ojuz";
const getData = (type: string, results: TSearchResults, resultModels?: Array<SearchResultEntryWithType>): Array<SearchResultEntry & {
  type?: string;
}> => {
  if (resultModels) return resultModels;
  const {
    data: searchResultData
  } = results;
  const {
    data: searchData
  } = safeObj(searchResultData?.[type as TabTypes]);
  if (searchData) return searchData;
  return [];
};
const openMenu = (slug: string) => {
  openMenuDialog(slug, {
    hideNextPrev: true,
    transitionSource: TransitionTypes.TILE
  });
};
interface ISearchResults {
  /** 'name' | 'topic' | 'tags' ('' if performing a search from the home page) */
  type: SearchType;
  loading?: boolean;
  resultModels?: Array<SearchResultEntryWithType>;
  searchResults: TSearchResults;
  onOpenMenu?(slug: string): void;
  onOpenRoom?(slug: string): void;
  onTagClick?(tag: string): void;
  onScroll?(offset: number): void;
}
const SearchResults = memo((props: ISearchResults) => {
  const {
    type,
    loading,
    onOpenMenu = openMenu,
    onOpenRoom = openRoom,
    searchResults,
    resultModels,
    onTagClick,
    onScroll
  } = props;
  const searchString = searchResults.query?.search || '';
  const isSearch = searchString !== '';
  const hasSearchResults = searchResults.data?.name?.data?.length > 0 || searchResults.data?.topic?.data?.length > 0 || searchResults.data?.tags?.data?.length > 0;
  const models = getData(type, searchResults, resultModels);
  if (!isSearch) return null;
  if (loading && models.length === 0) {
    return <SearchResultRoot className={'no-scrollbars'}>
                <LoadingData active />
            </SearchResultRoot>;
  }
  if (models.length === 0 || !hasSearchResults) {
    return <NoResults styleOverrides={noResultStyles} searchQuery={searchString} />;
  }
  return <SearchResultRoot data-testid="List__SearchResults" className={'no-scrollbars'}>
            <SearchRecommendations searchString={searchString} onTagClick={onTagClick} onOpenRoom={onOpenRoom} onOpenMenu={onOpenMenu} onScroll={onScroll} models={models} source={type} altDisplay />
        </SearchResultRoot>;
});
export default SearchResults;